/*
  NYGHT -- "Retur & reklamation" help behaviour (2026-10-08). Port of Cosnetic's cc-contact.js.
  - FAQ groups keep one answer open at a time.
  - The search box filters every question/answer on the page live and highlights the hit.
  - Pills mark the group in view.
  - Deflection: the "what is it about?" select shows that topic's answers first; the form only unfolds after
    "I still need help" (or straight away for a topic with no FAQ anchor, or when the page loads after a post so
    the success/error banner stays visible). Unfolding dispatches 'nn:reveal' so Turnstile renders.
  - Return portal (2026-10-21): picking a "Show return portal" topic sets sessionStorage nh-portal; after the post
    the success state unfolds the portal box once.
*/
(function () {
  if (window.nhHelpBoot) return;   // both sections load this file
  window.nhHelpBoot = true;
  var root = document;
  // strings via snippets/nyght-i18n (SE/NO 2026-10-24); Danish fallback if the snippet is missing
  var T = window.NyghtT || function (k, d) { return d; };

  /* single-open accordions */
  root.querySelectorAll('.nh-faqg').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var item = e.target;
      if (!item.open || !item.classList.contains('nh-faqg__item')) return;
      group.querySelectorAll('.nh-faqg__item[open]').forEach(function (o) { if (o !== item) o.open = false; });
    }, true);
  });

  /* search */
  var search = root.querySelector('[data-nh-search]');
  var hits = root.querySelector('[data-nh-hits]');
  function strip(el) { el.querySelectorAll('mark').forEach(function (m) { m.replaceWith(m.textContent); }); el.normalize(); }
  function mark(el, q) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      var i = t.nodeValue.toLowerCase().indexOf(q);
      if (i < 0) return;
      var m = document.createElement('mark'); m.textContent = t.nodeValue.substr(i, q.length);
      var after = t.splitText(i); after.nodeValue = after.nodeValue.substr(q.length);
      t.parentNode.insertBefore(m, after);
    });
  }
  if (search) {
    search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase(), total = 0;
      root.querySelectorAll('.nh-faqg').forEach(function (group) {
        var shown = 0;
        group.querySelectorAll('.nh-faqg__item').forEach(function (item) {
          var qEl = item.querySelector('summary strong'), aEl = item.querySelector('.np-q__a');
          strip(qEl); strip(aEl);
          var hit = !q || (qEl.textContent + ' ' + aEl.textContent).toLowerCase().indexOf(q) >= 0;
          item.hidden = !hit;
          if (hit && q.length >= 2) { mark(qEl, q); mark(aEl, q); item.open = true; }
          if (!q) item.open = false;
          shown += hit ? 1 : 0;
        });
        group.classList.toggle('is-empty', !!q && !shown);
        total += shown;
      });
      if (hits) hits.textContent = q ? (search.getAttribute('data-hits-label') || '{n}').replace('{n}', total) : '';
    });
  }

  /* pills follow scroll */
  var pills = root.querySelectorAll('.nh-pills__pill[href^="#"]');
  if (pills.length && 'IntersectionObserver' in window) {
    var byId = {};
    pills.forEach(function (p) { byId[p.getAttribute('href').slice(1)] = p; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        var p = byId[en.target.id]; if (p) p.classList.add('is-active');
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(byId).forEach(function (id) { var t = document.getElementById(id); if (t) io.observe(t); });
  }

  /* deflection */
  var block = root.querySelector('.nh-kc');
  if (!block) return;
  var select = block.querySelector('[data-nh-topic]');
  var hintsBox = block.querySelector('[data-nh-hints]');
  var hintsList = block.querySelector('[data-nh-hints-list]');
  var reveal = block.querySelector('[data-nh-reveal]');
  var form = block.querySelector('[data-nh-form]');
  var topicField = block.querySelector('[data-nh-topic-field]');
  var posted = /contact_posted=true|form_type=contact/.test(location.search + location.hash) || block.querySelector('.nh-kc__msg');
  function openItem(item) {
    var group = item.closest('.nh-faqg');
    group.querySelectorAll('.nh-faqg__item[open]').forEach(function (o) { o.open = false; });
    item.open = true;
    item.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function showForm(focus) {
    if (!form) return;
    form.hidden = false;
    document.dispatchEvent(new Event('nn:reveal'));
    var first = form.querySelector('input:not([type=hidden])');
    if (first && focus !== false) first.focus({ preventScroll: true });
  }
  if (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var anchor = opt.getAttribute('data-anchor');
      if (topicField) topicField.value = select.value ? opt.textContent.trim() : '';
      hintsList.innerHTML = '';
      var group = anchor ? document.getElementById(anchor) : null;
      if (group) {
        var items = group.querySelectorAll('.nh-faqg__item');
        Array.prototype.slice.call(items, 0, 4).forEach(function (item) {
          var li = document.createElement('li'); li.className = 'nh-kc__hint';
          var b = document.createElement('button'); b.type = 'button'; b.textContent = item.querySelector('summary strong').textContent;
          b.addEventListener('click', function () { openItem(item); });
          li.appendChild(b); hintsList.appendChild(li);
        });
        hintsBox.classList.toggle('is-on', items.length > 0);
        if (reveal) reveal.hidden = false;
        if (form && !posted) form.hidden = true;
      } else {
        hintsBox.classList.remove('is-on');
        if (reveal) reveal.hidden = true;
        if (select.value) showForm();
      }
    });
  }
  block.querySelectorAll('[data-nh-yes]').forEach(function (b) {
    b.addEventListener('click', function () {
      hintsBox.classList.remove('is-on'); if (reveal) reveal.hidden = true; if (form) form.hidden = true;
      select.value = ''; if (topicField) topicField.value = '';
      var top = root.querySelector('.nh-search') || document.body; top.scrollIntoView({ behavior: 'smooth' });
    });
  });
  block.querySelectorAll('[data-nh-no]').forEach(function (b) { b.addEventListener('click', function () { showForm(); }); });

  /* photos: required for topics marked "Requires photos"; uploaded on Send, links go into contact[Billeder] */
  var ph = block.querySelector('[data-nh-photos]');
  var formEl = form && form.querySelector('form');
  if (ph && formEl) {
    var min = +ph.getAttribute('data-min') || 1, max = +ph.getAttribute('data-max') || 6;
    var fileIn = ph.querySelector('[data-nh-file]'), thumbs = ph.querySelector('[data-nh-thumbs]');
    var err = ph.querySelector('[data-nh-photo-err]'), field = ph.querySelector('[data-nh-photo-field]');
    var btn = formEl.querySelector('[type="submit"]'), photos = [], busy = false;
    function say(msg) { err.textContent = msg || ''; err.hidden = !msg; }
    function draw() {
      thumbs.innerHTML = '';
      photos.forEach(function (p, i) {
        var li = document.createElement('li'); li.className = 'nh-kc__thumb';
        var img = document.createElement('img'); img.src = p.url; img.alt = '';
        var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', T('help_remove_photo', 'Fjern billede')); x.textContent = '×';
        x.addEventListener('click', function () { URL.revokeObjectURL(p.url); photos.splice(i, 1); draw(); });
        li.appendChild(img); li.appendChild(x); thumbs.appendChild(li);
      });
      ph.classList.toggle('is-full', photos.length >= max);
    }
    function shrink(file) {
      if (!window.createImageBitmap) return Promise.resolve(file);
      return createImageBitmap(file, { imageOrientation: 'from-image' }).then(function (bmp) {
        var s = Math.min(1, 1600 / Math.max(bmp.width, bmp.height)), c = document.createElement('canvas');
        c.width = Math.round(bmp.width * s); c.height = Math.round(bmp.height * s);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        return new Promise(function (res) { c.toBlob(function (b) { res(b || file); }, 'image/jpeg', 0.82); });
      }).catch(function () { return file; });
    }
    fileIn.addEventListener('change', function () {
      var list = Array.prototype.slice.call(fileIn.files || []).filter(function (f) { return /^image\//.test(f.type) || /\.(heic|heif)$/i.test(f.name); });
      fileIn.value = '';
      Promise.all(list.slice(0, max - photos.length).map(shrink)).then(function (blobs) {
        blobs.forEach(function (b) { photos.push({ blob: b, url: URL.createObjectURL(b) }); });
        draw(); if (photos.length >= min) say('');
      });
    });
    function needed() { return !ph.hidden; }
    function setTopicPhotos() {
      var opt = select && select.options[select.selectedIndex];
      ph.hidden = !(opt && opt.getAttribute('data-photos') === '1');
      if (ph.hidden) say('');
    }
    if (select) select.addEventListener('change', setTopicPhotos);
    formEl.addEventListener('submit', function (e) {
      if (!needed() || formEl.nhPhotosDone) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (busy) return;
      if (photos.length < min) { say((ph.getAttribute('data-err-min') || '').replace('{n}', min)); ph.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (!formEl.reportValidity()) return;
      var box = formEl.querySelector('.nn-turnstile'), token = box && box.nnToken;
      var fd = new FormData();
      fd.append('token', token || '');
      fd.append('order', (formEl.querySelector('[name="contact[Ordrenummer]"]') || {}).value || '');
      photos.forEach(function (p, i) { fd.append('photo', p.blob, 'foto-' + (i + 1) + '.jpg'); });
      busy = true; say('');
      var label = btn.textContent; btn.disabled = true; btn.textContent = ph.getAttribute('data-sending') || label;
      fetch(ph.getAttribute('data-upload'), { method: 'POST', body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.urls) throw j; return j.urls; }); })
        .then(function (urls) {
          field.value = urls.join('\n');
          formEl.nhPhotosDone = true;
          // 2026-10-14: requestSubmit, not prototype.submit -- a real submit event lets Shopify's hCaptcha script add
          // its token; prototype.submit skipped it and /contact answered "Missing CAPTCHA token" on every return.
          if (formEl.requestSubmit) formEl.requestSubmit();
          else { var go = document.createElement('button'); go.type = 'submit'; go.hidden = true; formEl.appendChild(go); go.click(); }
        })
        .catch(function () {
          busy = false; btn.textContent = label;
          say(ph.getAttribute('data-err-up'));
          // the token is single-use: get a fresh one; the Turnstile script re-enables Send when it is solved
          if (box && window.turnstile) { box.nnToken = ''; try { window.turnstile.reset(box); } catch (x) { btn.disabled = false; } }
          else btn.disabled = false;
        });
    }, true);
  }
  /* return portal: remember the topic over the post (set on pick, so no other submit handler can skip it),
     show the portal box under the success message */
  if (select) select.addEventListener('change', function () {
    var opt = select.options[select.selectedIndex];
    try { sessionStorage.setItem('nh-portal', opt && opt.getAttribute('data-portal') === '1' ? '1' : ''); } catch (x) {}
  });
  var portal = block.querySelector('[data-nh-portal]');
  if (portal) {
    var want = false;
    try { want = sessionStorage.getItem('nh-portal') === '1'; sessionStorage.removeItem('nh-portal'); } catch (x) {}
    if (want) portal.hidden = false;
  }
  if (posted) showForm(false);
})();
